export default __webpack_public_path__ + "34da874797f9bba05245f44a1b0794b1.png";